import { Field, FieldError, FieldLabel } from "@/components/ui";
import { Input } from "@/components/ui/Input";
import type {
  ControllerFieldState,
  ControllerRenderProps,
} from "react-hook-form";
import type { AOEQuestion } from "../../../network/useRetrieveAOEForOrder";
import type { AOEFormSchema } from "../schemas";

export const FreetextQuestion = ({
  question,
  field,
  fieldState,
  disabled,
}: {
  question: AOEQuestion;
  field: ControllerRenderProps<
    AOEFormSchema,
    `questionnaires.${string}.${string}`
  >;
  fieldState: ControllerFieldState;
  disabled: boolean;
}) => {
  return (
    <Field data-invalid={fieldState.invalid}>
      <FieldLabel htmlFor={field.name}>
        {`${question.required ? "*" : ""} ${question.question}`}
      </FieldLabel>
      <Input
        {...field}
        id={field.name}
        value={field.value as string}
        disabled={disabled}
        aria-invalid={fieldState.invalid}
      />
      <FieldError errors={[fieldState.error]} />
    </Field>
  );
};
